export const InventarioHeaderActions = ({ tabs = [], activeTab, onChangeTab }) => {
  return (
    <div className="inv-nav">
      {tabs.map(({ id, title, icon }) => {
        const active = title === activeTab;

        return (
          <button
            key={id}
            type="button"
            onClick={() => onChangeTab && onChangeTab(title)}
            aria-pressed={activeTab === title}
            className={`tab ${active && "activeTab"}`}
          >
            {icon && <img src={icon} alt={title} style={{ width: "20px", marginRight: "4px" }} />}
            {title && <span>{title}</span>}
          </button>
        );
      })}
    </div>
  );
};
